<header>
    <div class="header" style="display:block">
        {{heading}}
    </div>
</header>


<div style="position: relative;">
    <form [formGroup]="addForm" (ngSubmit)="submitForm()">
        <div class="formbody" fxLayout="row wrap" fxLayoutGap="15px grid">
            <div fxFlex="100%">
                <app-notification-message [errorMessage]="errorMessage"></app-notification-message>
            </div>
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Type</label></div>
                <div style="margin:10px">
                    <div>
                        <select class="form-control-sm" formControlName="type"
                            [ngClass]="{'is-invalid': submitted && f['type'].errors}">
                            <option value="Supplier">Supplier</option>
                            <option value="Route">Route</option>
                        </select>
                    </div>

                    <div style="min-height:10px;">
                        <div *ngIf="submitted && f['type'].errors" class="error-message">
                            <div *ngIf="f['type'].errors['required']">Type is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Category</label></div>
                <div style="margin:10px">
                    <div>
                        <input type="text" class="form-control" formControlName="category" maxlength="100"
                            [ngClass]="{'is-invalid': submitted && f['category'].errors}">
                    </div>

                    <div style="min-height:10px;">
                        <div *ngIf="submitted && f['category'].errors" class="error-message">
                            <div *ngIf="f['category'].errors['required']">Category is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Detail</label></div>
                <div style="margin:10px">
                    <div>
                        <input type="text" class="form-control" formControlName="detail"
                            [ngClass]="{'is-invalid': submitted && f['detail'].errors}" maxlength="100">
                    </div>

                    <div style="min-height:10px;">
                        <div *ngIf="submitted && f['detail'].errors" class="error-message">
                            <div *ngIf="f['detail'].errors['required']">Detail is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">HHT Description</label></div>
                <div style="margin:10px">
                    <div>
                        <input type="text" class="form-control" formControlName="hhtDescription"
                            [ngClass]="{'is-invalid': submitted && f['hhtDescription'].errors}"
                            maxlength="30">
                    </div>

                    <div style="min-height:10px;">
                        <div *ngIf="submitted && f['hhtDescription'].errors" class="error-message">
                            <div *ngIf="f['hhtDescription'].errors['required']">HHT Description is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Inactive</label></div>
                <div style="margin:10px">
                    <div>
                        <input type="checkbox" class="form-control-sm chkBox" formControlName="inactive">
                    </div>
                </div>
            </div>


        </div>






        <div class="footerp cfooter">
            <label class="cancel" style="position: relative;
                right: 27px;" (click)="onNoClick()"> CANCEL
            </label>
            <button mat-raised-button class="submit" type="submit"
                style="display: inline;margin-right: 4%;">SAVE</button>
        </div>
    </form>
</div>


<!-- <form [formGroup]="addForm" (ngSubmit)="submitForm()" style="top:0 ; position: relative;">
    <div class="container content">
        <div class="form-group row">
            <label class="col-sm-1 col-form-label">Type</label>
            <div class="col-sm-3">
                <select formControlName="type" [ngClass]="{'is-invalid': submitted && f['category'].errors}">
                    <option value="Supplier">Supplier</option>
                    <option value="Route">Route</option>
                </select>
                <div *ngIf="submitted && f['type'].errors" class="invalidFormat">
                    <div *ngIf="f['type'].errors['required']">Type is required</div>
                </div>
            </div>


            <label class="col-sm-1 col-form-label">Category</label>
            <div class="col-sm-3">
                <input type="text" class="form-control" formControlName="category"
                    [ngClass]="{'is-invalid': submitted && f['category'].errors}" (keypress)="dockdoor($event)"
                    (paste)="onPaste($event)">
                <div *ngIf="submitted && f['category'].errors" class="invalidFormat">
                    <div *ngIf="f['category'].errors['required']">Category is required</div>
                </div>
            </div>


            <label class="col-sm-1 col-form-label">Detail</label>
            <div class="col-sm-3">
                <input type="text" class="form-control" formControlName="detail"
                    [ngClass]="{'is-invalid': submitted && f['detail'].errors}" (keypress)="dockdoor($event)"
                    (paste)="onPaste($event)">
                <div *ngIf="submitted && f['detail'].errors" class="invalidFormat">
                    <div *ngIf="f['detail'].errors['required']">Detail is required</div>
                </div>
            </div>
        </div>
        <br>

        <div class="form-group row">
            <label class="col-sm-1 col-form-label" style="margin-top: -1%;">HHT Description</label>
            <div class="col-sm-3">
                <input type="text" class="form-control" formControlName="hhtDescription"
                    [ngClass]="{'is-invalid': submitted && f['hhtDescription'].errors}" (keypress)="dockdoor($event)"
                    (paste)="onPaste($event)">
                <div *ngIf="submitted && f['hhtDescription'].errors" class="invalidFormat">
                    <div *ngIf="f['hhtDescription'].errors['required']">HHT Description is required</div>
                </div>
            </div>

            <label class="col-sm-1 col-form-label lbl">Inactive</label>
            <div class="col-sm-1">
                <input type="checkbox" class="form-control chkBox" formControlName="inactive">
            </div>
        </div>
        <br>


    </div>
</form>

<app-notification-message [errorMessage]="errorMessage" class="notf"></app-notification-message>

<div class="footer cfooter">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button type="submit" class="submit ml-2" style="display: inline;"
        (click)="submitForm()">SAVE</button>
</div> -->